export default __webpack_public_path__ + "static/media/legitimation.badc0289.png";